import { IContact } from "@rentiohq/shared-frontend/dist/types/contact.types";
import { getLocalizedText } from "@rentiohq/shared-frontend/dist/utils/i18n/i18n.utils";
import { TContactType } from "@rentiohq/web-shared/dist/types";
import { Form } from "@rentiohq/web-shared-next/dist/ui-components";
import { IFormikValues } from "@rentiohq/web-shared-next/dist/utils/types/form";
import { addCompanySchema } from "../../../forms/addCompany";
import { addContactSchema } from "../../../forms/addContact";

export interface IProps {
  openDialog: boolean;
  selectedContact?: IContact;
  contactType: TContactType;
  onClose: () => void;
  onSubmit: (formData: IFormikValues) => void;
}

export const AddContactModal = ({
  openDialog,
  selectedContact,
  contactType,
  onClose,
  onSubmit,
}: IProps) => {
  return (
    <Form
      renderAsModal={true}
      onSubmit={onSubmit}
      getSchema={
        contactType === "company"
          ? addCompanySchema({
              isCompany: true,
              showSendInvite: true,
              contact: selectedContact,
            })
          : addContactSchema({
              isCompany: false,
              showSendInvite: true,
              contact: selectedContact,
            })
      }
      asMultiStep={true}
      modalProps={{
        modalTitle: getLocalizedText(
          contactType === "company" ? "company.add" : "contact.add",
        ),
        openDialog,
        handleClose: onClose,
        maxWidth: "1000px",
        width: "1000px",
      }}
    />
  );
};
